<template>
  <div class="recharge-picking">
    <h1 class="title">选择充值金额</h1>
    <ul class="cards">
      <li :class="{'checked': activityIndex === index}" v-for="(card, index) in cards" :key="index" @click="handleClick(card, index)">
        <p>{{card.price}}知米</p>
        <p class="money">{{card.price}}元</p>
      </li>
    </ul>
    <UIButton class="button" @click="pay">充值</UIButton>
    <ul class="desc">
      <li>1.充值前，请检查你的登录账户是否正确</li>
      <li>2.充值成功后，知米不可转移，不可退款，不可提现。</li>
      <li>3.苹果设备或安卓设备登录同一账户，购买的商品可以同步使用</li>
    </ul>
  </div>
</template>

<script>
  import UIButton from '../../components/UI/Button'
  export default {
    name: "Picking",
    data () {
      return {
        activityIndex: 0,
      }
    },
    props: ['cards'],
    methods: {
      handleClick (card, index) {
        this.activityIndex = index
        this.$emit('chooseMoney', card)
      },
      pay () {
        this.$emit('showNotice')
      }
    },
    components: {
      UIButton,
    }
  }
</script>

<style scoped lang="scss">
  @charset "UTF-8";
  @import "../../style/main";
  .recharge-picking {
    background-color: #fff;
    padding: rem(40) rem(30);
    .title {
      font: {
        size: rem(32);
        weight: bolder;
      };
      color: #333;
      line-height: rem(45);
      margin-bottom: rem(40);
    }
    .button {
      font: {
        size: rem(32);
        weight: bolder;
      };
      margin-bottom: rem(40);
    }
    .desc {
      font-size: rem(26);
      color: #999999;
      > li {
        line-height: rem(37);
        margin-bottom: rem(10);
      }
    }
    .cards {
      font: {
        size: rem(32);
      };
      color: #333;
      > li {
        display: inline-block;
        padding: rem(20) 0;
        box-sizing: border-box;
        border: rem(2) solid #CCCCCC;
        border-radius: rem(10);
        width: rem(216);
        height: rem(129);
        text-align: center;
        margin-right: rem(21);
        margin-bottom: rem(21);
        &:nth-child(3n) {
          margin-right: 0;
        }
        > p {
          line-height: 1.4;
          margin-bottom: rem(4);
          &:last-child {
            font-size: rem(28);
            color: #999;
            margin-bottom: 0;
          }
        }
      }
      .checked {
        color: #F49000;
        border: rem(2) solid #F49000;
        .money {
          color: #F49000;
        }
      }
    }
  }
</style>
